<template>
 <v-dialog
    width="600px"
    v-model="showRecentlyUpdatedWarning"
  >
    <div class="dashboard-dialog-window">
      <div class="dashboard-dialog-window__message">
        {{ $ucfirst($t('dss.prescriptionRecentlyUpdated')) }}
      </div>
      <div class="dashboard-dialog-window__actions">
        <v-btn
          x-large
          text
          class="ml-4"
          @click="showRecentlyUpdatedWarning = false"
        >
          {{ $ucfirst($t('confirm')) }}
        </v-btn>
        <v-btn
          x-large
          text
          class="ml-4"
          @click="goBack"
          color="primary"
        >
          {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import RouterHistory from '../../../../router/hooks/router-history';

/**
 * Component PrescriptionRecentlyUpdatedPopup.vue
 *
 * @module PrescriptionRecentlyUpdatedPopup
 * @date 12/09/2022
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSS/PrescriptionRecentlyUpdatedPopup.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PrescriptionRecentlyUpdatedPopup',
  props: {},
  methods: {
    goBack() {
      RouterHistory.back(1, {
        name: 'PatientOverview',
        params: { patientId: this.patientId }
      })
    }
  },
  computed: {
    patientId() {
      return this.$store.getters['patientSummary/id'];
    },
    showRecentlyUpdatedWarning: {
      get() {
        return this.$store.getters['dss/prescriptionRecentlyUpdatedWarning']
      },
      set(value) {
        this.$store.dispatch('dss/setPrescriptionRecentlyUpdatedWarning', value)
      }
    }
  },
};
</script>
